import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { QUERY_KEYS } from '~constants'
import { getUserDiscountsList, writeToStorageCacheQuery } from '~services'
import { UserDiscountsListResponse } from '~types/user'
import { useGetQueryState } from '~utils'

const { USER_DISCOUNTS_LIST } = QUERY_KEYS

const userDiscountsListQueryKey = [USER_DISCOUNTS_LIST] as [string]

export function useGetUserDiscountsList(
  options?: UseQueryOptions<UserDiscountsListResponse, unknown, UserDiscountsListResponse>
) {
  const cachedData = useGetQueryState<UserDiscountsListResponse>(userDiscountsListQueryKey)

  const { isLoading: isLoadingUserDiscountsList, refetch: refetchUserDiscountsList } =
    useQuery<UserDiscountsListResponse>(userDiscountsListQueryKey, getUserDiscountsList, {
      keepPreviousData: true,
      onSuccess: (data) => {
        writeToStorageCacheQuery(userDiscountsListQueryKey, data)
      },
      ...options,
    })

  return {
    userDiscountsList: cachedData?.discount,
    isLoadingUserDiscountsList,
    refetchUserDiscountsList,
  }
}

useGetUserDiscountsList.queryKey = () => userDiscountsListQueryKey
